import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, TabPanel } from '@tencent/spaui';
import ArticleList from '../component/articleList';
export const LinkComponent = (props = {}) => {
  const { children, name, onClick, disabled, href } = props;
  return (
    <a href={href} onClick={onClick} data-name={name}>
      {children}
    </a>
  );
};
class List extends Component {
  render() {
    const { catalogList = [], catalogId = {} } = this.props;
    const value = this.props.match.params[0].split('/')[2];
    return (
      <div className="help_detail_container">
        <div className="help_content_main">
          {catalogList.length ? (
            <React.Fragment>
              <div className="help_content_main_title">{catalogId.name}</div>
              <div id="categoryTab">
                <Tabs value={value} className="sec-tab" LinkComponent={LinkComponent}>
                  {catalogList.map((v) => {
                    return (
                      <TabPanel tab={v.label} name={v.key} key={v.key} href={`${v.href}`} data-hot-tag="abc">
                        <ArticleList Id={v.key} key={v.key} />
                      </TabPanel>
                    );
                  })}
                </Tabs>
              </div>
            </React.Fragment>
          ) : (
            <ArticleList Id={catalogId.value} />
          )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    navlist: state.knowledge.knowledge_list,
    catalogList: state.knowledge.knowledge_catalogList,
    catalogId: state.knowledge.knowledge_catalogId,
  };
}
export default connect(mapStateToProps)(List);
